<template>
    <div align="center">
        <v-img id="image" gradient="rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8)" src="@/assets/images/foldgaz.jpg">
            <div align="start" :style="$vuetify.breakpoint.mdAndUp ? 'width:60vw':'width:90vw'" class="fill-height">
                <v-row no-gutters align-content="end" class="fill-height"><h1 class="white--text" :style="$vuetify.breakpoint.mdAndUp ? 'font-size:6rem':'font-size:3.5rem'">Termékek</h1></v-row>
            </div>
        </v-img>
        <v-row no-gutters class="title_bar" v-if="$vuetify.breakpoint.mdAndUp">
            <div  style="width:55vw"><h1 class="py-1">Beltéri gyártmányok</h1></div>
        </v-row>

        <v-row no-gutters class="title_bar" v-else><h2 class="py-1 ml-5">Beltéri gyártmányok</h2></v-row>
        <!--<div style="width:70vw">
            
            <v-row :justify="$vuetify.breakpoint.smAndUp ? 'start':'center'" class="my-3">
                <Product
                    align="start"
                    v-for="item in items"
                    :key="item.id"
                    :id="item.id" :type_id="item.type_id" :product_name="item.name" :description="item.description" :index_picture="item.index_picture"/>
                <Product2 />
                <Product2/>
                <Product2/>
                <Product2/>
                <Product2/>
                <Product2/>
                <Product2/>

                <Product2/>
                <Product2/>
            </v-row>
        </div>-->
            <v-row  class="ma-5" justify="center">
                <Product2 v-for="item in items"
                    :key="item.id"
                    :id="item.id" :type_id="item.type_id" :product_name="item.name" :description="item.description" :index_picture="item.index_picture" admin/>
            </v-row>     
    </div>
</template>

<script>
import Product from '@/components/Product.vue'
import Product2 from '@/components/Product2.vue'
import api from '@/util/api_util'
import ImageUtil from '@/util/image_util.js'
export default {
    components:{
        Product,
        Product2
    },
    data(){
        return{
            items:[],
            index_pic:"images/index_picture/fc.png"
        }
    },
    created:function(){
        api.post("/item/list",{"type_id":"1"}).then(response => {
            this.items = response.datas
            console.log(response);     
        });
        
        this.index_pic = ImageUtil.loadImage(this.index_pic);
    }
}
</script>
<style scoped>
    #image{
        height:250px;
    }
    .title_bar{
        background-color: #920825;
        color: white;
    }
    .subtitle{
        color: #920825;
    }
</style>